import { TabsProps } from 'rc-tabs';
import React from 'react';

import * as S from './styles';
import { TabSize } from './types';

type Props = React.PropsWithChildren<
  {
    size?: TabSize;
    centered?: boolean;
  } & TabsProps
>;

export const Tabs: React.FC<Props> & { TabPane: typeof S.TabPane } = ({
  size = 'normal',
  ...props
}) => {
  return <S.Tabs $size={size} {...props}></S.Tabs>;
};

Tabs.TabPane = S.TabPane;
